export function formatSelfServiceCurrency(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const parsed = Number.parseFloat(value);
  if (Number.isNaN(parsed)) {
    return value;
  }
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(parsed);
}

export function formatSelfServiceStatus(status: string | null | undefined): string {
  if (!status) {
    return '—';
  }
  return status
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatSelfServiceDate(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const parsed = dateOnlyMatch
    ? new Date(
      Number(dateOnlyMatch[1]),
      Number(dateOnlyMatch[2]) - 1,
      Number(dateOnlyMatch[3]),
    )
    : new Date(value);

  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function splitAudienceParts(audience: string | string[] | null | undefined): string[] {
  if (audience === null || audience === undefined) {
    return [];
  }

  const rawParts = Array.isArray(audience) ? audience : [audience];

  return rawParts
    .flatMap((value) => String(value).split(/\r?\n/))
    .map((part) => part.trim())
    .filter(Boolean);
}

export function formatSelfServiceAudience(audience: string | string[] | null | undefined): string {
  const parts = splitAudienceParts(audience);
  return parts.length > 0 ? parts.join(', ') : '—';
}
